import { fg } from '@atlaskit/platform-feature-flags';

import type { NodeTransformer } from './types';

export const toSupportedPanel: NodeTransformer = (partialNodeJson) => {
	if (partialNodeJson.attrs?.panelType === 'tip' && fg('platform_editor_convert_tip_to_info')) {
		return {
			...partialNodeJson,
			attrs: { ...partialNodeJson.attrs, panelType: 'info' },
		};
	}

	return partialNodeJson;
};
